import { theme } from '../../styles/_variables'

export const addressType = {
  BILLING: 'BILLING',
  SHIPPING: 'SHIPPING',
  CONTACT: 'CONTACT',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}

export const STATUS = [
  { value: 'ALL', text: 'ทั้งหมด' },
  { value: 'WAITING_SUPPLIER', text: 'รอผู้ผลิตยืนยัน' },
  { value: 'SUPPLIER_CF', text: 'ผู้ผลิตยืนยันแล้ว' },
  { value: 'PARTIAL_RECEIVED', text: 'ได้รับแล้วบางส่วน' },
  { value: 'COMPLETED', text: 'สำเร็จแล้ว' },
  { value: 'CANCELLED', text: 'ยกเลิก' },
  { value: 'SHIPMENT_OVERDUE', text: 'เลยกำหนด' },
  { value: 'INACTIVE', text: 'INACTIVE' },
]

export const STATUSTEXTSELECTOR = (status) => {
  switch (status) {
    case STATUS[0].value:
      return STATUS[0].text
    case STATUS[1].value:
      return STATUS[1].text
    case STATUS[2].value:
      return STATUS[2].text
    case STATUS[3].value:
      return STATUS[3].text
    case STATUS[4].value:
      return STATUS[4].text
    case STATUS[5].value:
      return STATUS[5].text
    case STATUS[6].value:
      return STATUS[6].text
    case STATUS[7].value:
      return STATUS[7].text
    default:
      return 'ไม่ระบุ'
  }
}

export const STATUSCOLORSELECTOR = (status) => {
  switch (status) {
    case STATUS[0].value:
      return '#97A0AF'
    case STATUS[1].value:
      return STATUS[1].text
    case STATUS[2].value:
      return '#38B47F'
    case STATUS[3].value:
      return '#a9c268'
    case STATUS[4].value:
      return '#00B8D9'
    case STATUS[5].value:
      return '#FF5B37'
    default:
      return '#333'
  }
}

export const ORDERITEMSTATUS = [
  { value: 'WAITING_SUPPLIER', text: 'รอผู้ผลิตยืนยัน' },
  { value: 'SUPPLIER_CF', text: 'ผู้ผลิตยืนยันแล้ว' },
  { value: 'PARTIAL_RECEIVED', text: 'ได้รับแล้วบางส่วน' },
  { value: 'RECEIVED', text: 'ได้รับแล้ว' },
  { value: 'RECEIVE_OVERDUE', text: 'เกินกำหนดรับสินค้า' },
  { value: 'COMPLETED', text: 'ยกเลิก' },
  { value: 'CANCELLED', text: 'สำเร็จแล้ว' },
]

export const ITEM_KEYS = {
  waiting: 'WAITING_SUPPLIER',
  supplierConfirm: 'SUPPLIER_CF',
  watingPayment: 'WAITING_PAYMENT',
  watingPO: 'WAITING_PO',
  watingSupplier: 'WAITING_SUPPLIER',
  supplierCf: 'SUPPLIER_CF',
  partialReceived: 'PARTIAL_RECEIVED',
  received: 'RECEIVED',
  receiveOverdue: 'RECEIVE_OVERDUE',
  cancelledPo: 'CANCELLED_PO',
  preparing: 'PREPARING',
  watingShipment: 'WAITING_SHIPMENT',
  complete: 'COMPLETED',
  cancelled: 'CANCELLED',
  shipmentOverdue: 'SHIPMENT_OVERDUE',
  returned: 'RETURNED',
  refunded: 'REFUNDED',
  error: 'ERROR',
  inactive: 'INACTIVE',
}

export const ITEM_STATUS = [
  {
    key: ITEM_KEYS.waiting,
    text: 'รอ Supplier ยืนยัน',
    color: theme.color.heather,
    icon: 'fal fa-pause-circle',
  },
  {
    key: ITEM_KEYS.supplierConfirm,
    text: 'Supplier ยืนยัน',
    color: theme.color.heather,
    icon: 'fal fa-pause-circle',
  },
  {
    key: ITEM_KEYS.partialReceived,
    text: 'รับของบางส่วน',
    color: theme.color.heather,
    icon: 'fal fa-pause-circle',
  },
  {
    key: ITEM_KEYS.received,
    text: 'รับสินค้าทั้งหมด',
    color: theme.color.heather,
    icon: 'fal fa-pause-circle',
  },
  {
    key: ITEM_KEYS.receiveOverdue,
    text: 'เกินกำหนดรับสินค้า',
    color: theme.color.warning,
    icon: 'fal fa-pause-exclamation-circle',
  },
  {
    key: ITEM_KEYS.complete,
    text: 'สำเร็จ',
    color: theme.color.success,
    icon: 'fal fa-pause-check',
  },
  {
    key: ITEM_KEYS.cancelled,
    text: 'ยกเลิก',
    color: theme.color.error,
    icon: 'fal fa-pause-print-slash',
  },
]
